import DeliveryDayIcon from './DeliveryDayIcon';

export default DeliveryDayIcon;
